// @mui
import { Box, BoxProps } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// config
// components
import { useSettingsContext } from 'src/components/settings/utils';
import { useLayout } from 'src/contexts/LayoutContext';

// ----------------------------------------------------------------------

const SPACING = 8;

export default function Main({ children, sx, ...other }: BoxProps) {
  const { themeLayout } = useSettingsContext();
  const { headerLayout, navLayout } = useLayout();

  const isNavHorizontal = themeLayout === 'horizontal';

  const isNavMini = themeLayout === 'mini';

  const isDesktop = useResponsive('up', 'lg');

  if (isNavHorizontal) {
    return (
      <Box
        component="main"
        sx={{
          pt: `${headerLayout.H_MOBILE + SPACING}px`,
          pb: `${headerLayout.H_MOBILE + SPACING}px`,
          ...(isDesktop && {
            px: 2,
            pt: `${headerLayout.H_DASHBOARD_DESKTOP + 80}px`,
            pb: `${headerLayout.H_DASHBOARD_DESKTOP + SPACING}px`,
          }),
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: `${headerLayout.H_MOBILE + SPACING}px`,
        ...(isDesktop && {
          px: 2,
          py: `${headerLayout.H_DASHBOARD_DESKTOP + 0 + SPACING}px`,
          width: `calc(100% - ${navLayout.W_DASHBOARD}px)`,
          ...(isNavMini && {
            width: `calc(100% - ${navLayout.W_DASHBOARD_MINI}px)`,
          }),
        }),
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}
